'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIIconButton from 'UIComponents/button/UIIconButton';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
const ButtonGroup = styled.div.withConfig({
  displayName: "TrackAwardModalSharing__ButtonGroup",
  componentId: "sc-1pb45ve-0"
})(["margin:20px 0 40px 0;@media (min-width:", "){margin-bottom:80px;}"], GRID_BREAKPOINT_SMALL);

const TrackAwardModalSharing = ({
  certFileName,
  certObjectUrl,
  onClickShareThis,
  onDownloadCertificate,
  shareThisPath
}) => {
  const history = useHistory();
  const location = useLocation();
  const clickShareThis = useCallback(() => {
    onClickShareThis();
    history.push(shareThisPath, {
      backFromAwardShare: location
    });
  }, [history, location, shareThisPath, onClickShareThis]);
  const isNarrow = useMediaQuery(`screen and (max-width: ${GRID_BREAKPOINT_SMALL})`);
  return /*#__PURE__*/_jsxs(ButtonGroup, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      className: "p-x-2",
      "data-test-id": "share-this-button",
      onClick: clickShareThis,
      responsive: false,
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        className: isNarrow ? 'm-x-2' : 'm-x-0',
        message: "learningCenter.trackAwardModal.shareThisCertificate"
      })
    }), /*#__PURE__*/_jsx(UIIconButton, {
      "data-test-id": "award-download-button",
      disabled: !certObjectUrl,
      download: certFileName,
      href: certObjectUrl,
      onClick: onDownloadCertificate,
      responsive: false,
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.trackAwardModal.downloadCertificate"
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "download"
      })
    })]
  });
};

TrackAwardModalSharing.propTypes = {
  certFileName: PropTypes.string,
  certObjectUrl: PropTypes.string,
  onClickShareThis: PropTypes.func.isRequired,
  onDownloadCertificate: PropTypes.func.isRequired,
  shareThisPath: PropTypes.string.isRequired
};
export default TrackAwardModalSharing;